import script from "./material-shaped-icon.vue?vue&type=script&setup=true&lang=ts"
export * from "./material-shaped-icon.vue?vue&type=script&setup=true&lang=ts"

import "./material-shaped-icon.vue?vue&type=style&index=0&id=382fb4dd&scoped=true&lang=scss"

import exportComponent from "/builds/snedson/snotra-backend/snotra-front-ts/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-382fb4dd"]])

export default __exports__